// Уведомления в колокольчике (contracts/api.md; ADR-0021). Опрос идёт с X-KP-Background: 1.
import { z } from '../kernel/zod.ts';
import { InboxTabSchema, NotificationSchema } from '../kernel/notification.ts';

/**
 * GET /api/notifications: unread=true — только непрочитанные; 032 (FR-001) — tab: вкладка
 * «Входящих», нет — «Все».
 */
export const NotificationsQuerySchema = z.object({
  unread: z.stringbool().optional(),
  tab: InboxTabSchema.optional(),
  /** 0.26.1 (ACC-06): только нерешённые «требует действия» — прочитанные тоже. */
  open: z.stringbool().optional(),
});
export type NotificationsQuery = z.input<typeof NotificationsQuerySchema>;

export const NotificationsResponseSchema = z.object({
  items: z.array(NotificationSchema),
  unreadCount: z.number().int().nonnegative(),
  /**
   * 032 (FR-003, SC-005): непрочитанные «требует действия» — счётчик «Входящих» в меню
   * и у колокольчика.
   */
  actionUnread: z.number().int().nonnegative(),
  /** 0.26.1 (ACC-06): нерешённые «требует действия» — непрочитанные и прочитанные. */
  openCount: z.number().int().nonnegative(),
  /** 032 (FR-001): непрочитанные по вкладкам — считает сервер, а не 100 строк ленты. */
  tabUnread: z.object({
    all: z.number().int().nonnegative(),
    assigned: z.number().int().nonnegative(),
    due: z.number().int().nonnegative(),
    changes: z.number().int().nonnegative(),
  }),
});
export type NotificationsResponse = z.infer<typeof NotificationsResponseSchema>;
